<template>
  <header>
    <label for="toggle-1" class="toggle-menu" @click="toggleMenu"
      ><ul>
        <li></li>
        <li></li>
        <li></li></ul
    ></label>
    <!-- <strong @click="toggleMenu"> &#9776;	</strong> -->
    <nav
      class="nav_center"
      style="padding: 0"
      :style="{ display: isMenuVisible ? 'block' : 'none' }"
    >
      <ul style="list-style: none">
        <li
          :class="{ topmenuactive: activeTab === 'ThietBi' }"
          @click="changeTab('ThietBi')"
        >
          <a id="urlGioithieu" href="thietbivadichvu#ThietBi/">{{
            currentLanguage.header_text_thietBi_thietBi
          }}</a>
        </li>
        <li
          :class="{ topmenuactive: activeTab === 'DichVu' }"
          @click="changeTab('DichVu')"
        >
          <a id="urlBai1" href="thietbivadichvu#DichVu/">{{
            currentLanguage.footer_text_dichVu
          }}</a>
        </li>
        <!-- <li :class="{ topmenuactive: activeTab === 'HeThong' }" @click="changeTab('HeThong')">
          <a id="urlBai2" href="thietbivadichvu#HeThong/">{{ currentLanguage.header_text_chuyenDoiSo_caiDat }}</a>
        </li> -->
      </ul>
    </nav>
    <div class="menu_right" style="display: flex">
      <a @click="changeLanguage('vi')" class="lang" style="padding: 5px"
        ><img src="img/img-item-vimass-2022/co/vi-VN.gif" />
      </a>
      <a @click="changeLanguage('en')" class="lang" style="padding: 5px"
        ><img style="width: 25px" src="img/img-item-vimass-2022/co/us.png" />
      </a>
      <a @click="changeLanguage('cn')" class="lang" style="padding: 5px"
        ><img style="width: 25px" src="img/img-item-vimass-2022/co/cn.jpg" />
      </a>
      <a @click="changeLanguage('kr')" class="lang" style="padding: 5px"
        ><img style="width: 25px" src="img/img-item-vimass-2022/co/kr.jpg" />
      </a>

      <!-- <a onclick="changeLang('hi')" class="lang"
          ><img style="width: 25px" src="img/img-item-vimass-2022/co/hi.png" />
        </a> -->
      <span
        class="clickShow"
        style="color: #ffffff; cursor: pointer; margin: auto; padding: 5px"
        ><i class="fa fa-ellipsis-h" aria-hidden="true"></i
      ></span>
      <div class="showCo" style="display: none; margin: auto">
        <a onclick="changeLang('us')" class="lang"
          ><img src="img/img-item-vimass-2022/co/indo.jpg" />
        </a>
        <a onclick="changeLang('us')" class="lang"
          ><img src="img/img-item-vimass-2022/co/tl.png" />
        </a>
        <a onclick="changeLang('us')" class="lang"
          ><img src="img/img-item-vimass-2022/co/thailan.png" />
        </a>
        <a onclick="changeLang('us')" class="lang"
          ><img src="img/img-item-vimass-2022/co/hu.jpg" />
        </a>
      </div>
      <a id="urlHome" href="/" style="margin: 0 10px"
        ><img
          style="width: 35px; height: 35px"
          src="img/home-icon-white-8.jpg"
        />
      </a>
    </div>
  </header>
  <div class="row3">
    <main class="hoc container-fluid clear bv p-0">
      <main class="hoc container-fluid clear bv p-0">
        <!-- thiet bi-->
        <div id="ThietBi" v-show="showThietBi" style="min-height: 500px">
          <MainThietBiVue></MainThietBiVue>
        </div>
        <!-- DichVu-->
        <div
          id="DichVu"
          v-show="showDichVu"
          style="min-height: 500px; background-image: none !important"
        >
          <MainDichVuVue></MainDichVuVue>
        </div>
        <!-- HeThong -->
        <!-- <div id="HeThong"  v-show="showHeThong"  style="min-height: 500px; background-image: none !important"      >
            <MainHeThongVue></MainHeThongVue>

            </div> -->
      </main>
    </main>
  </div>
  <FooterView></FooterView>
</template>
  <script>
import FooterView from "@/views/Vimass/Footer/FooterView.vue";
import { languages } from "@/components/languages";
import MainThietBiVue from "../MainBaiVietCon/ThietBiVaDichVu/MainThietBi.vue";
import MainDichVuVue from "../MainBaiVietCon/ThietBiVaDichVu/MainDichVu.vue";
// import MainHeThongVue from '../MainBaiVietCon/ThietBiVaDichVu/MainHeThong.vue';

export default {
  components: {
    MainThietBiVue,
    MainDichVuVue,
    // MainHeThongVue,
    FooterView,
  },
  data() {
    return {
      activeTab: "ThietBi",
      isMenuVisible: false,

      currentLanguage: languages.vi,
      lang: "",
      base64: "",
      base64Title: "",

      //show
      showThietBi: true,
      showDichVu: false,
      // showHeThong: false,

      //active tab
      isActiveThietBi: true,
      isActiveDichVu: false,
      // isActiveHeThong: false,

      hasMounted: false,
    };
  },
  watch: {
    $route(to, from) {
      // Xử lý khi URL thay đổi
      console.log("URL đã thay đổi từ", from.fullPath, "đến", to.fullPath);
      let url = to.fullPath;
      console.log("vois" + url);
  
      switch (true) {
        case url.indexOf("ThietBi") !== -1:
          this.changeTab("ThietBi");
          break;
        case url.indexOf("DichVu") !== -1:
          this.changeTab("DichVu");
          break;
       
        default:
      }
    },
  },
  mounted() {
    if (window.innerWidth <= 768) {
      this.isMenuVisible = false;
    } else {
      this.isMenuVisible = true;
    }
    if (!this.hasMounted) {
      this.hasMounted = true; // Set the flag to true to indicate that mounted has been executed
      this.lang = localStorage.getItem("languages");
      if (this.lang == "vi") {
        document.title = "Vimass.vn - Thiết bị và dịch vụ";
      } else if (this.lang == "en") {
        document.title = "Vimass.vn - Device & Services";
      } else if (this.lang == "cn") {
        document.title = "Vimass.vn - 设备和服务";
      } else if (this.lang == "kr") {
        document.title = "Vimass.vn - 장비 및 서비스";
      }
      // window.location.href = this.lang + "/thietbivadichvu#ThietBi/";
      document.getElementById("urlHome").setAttribute("href", this.lang);
      document
        .getElementById("urlGioithieu")
        .setAttribute("href", this.lang + "/thietbivadichvu#ThietBi/");
      document
        .getElementById("urlBai1")
        .setAttribute("href", this.lang + "/thietbivadichvu#DichVu/");
      // document.getElementById('urlBai2').setAttribute('href', this.lang + '/thietbivadichvu#HeThong/');
    }
    const hash = window.location.hash;
    if (hash && hash.includes("#ThietBi")) {
      this.changeTab("ThietBi");
    } else if (hash && hash.includes("#DichVu")) {
      this.changeTab("DichVu");
    }
  },
  created() {
    const savedLanguage = localStorage.getItem("languages");
    if (savedLanguage && languages[savedLanguage]) {
      this.currentLanguage = languages[savedLanguage];
    }
  },
  methods: {
    changeLanguage(lang) {
      this.currentLanguage = languages[lang];
      localStorage.setItem("languages", lang);
      // window.location.reload();
      window.location.href = "/" + lang + "/thietbivadichvu#ThietBi/";
    },
    toggleMenu() {
      this.isMenuVisible = true;
    },
    changeTab(tab) {
      if (window.innerWidth <= 768) {
        this.isMenuVisible = false;
      }
      this.lang = localStorage.getItem("languages");

      if (tab === "ThietBi") {
        this.isActiveThietBi = true;
        this.isActiveDichVu = false;
        this.isActiveHeThong = false;
      } else if (tab === "DichVu") {
        this.isActiveThietBi = false;
        this.isActiveDichVu = true;
        this.isActiveHeThong = false;
      }
      // else if (tab === 'HeThong') {
      //   this.isActiveThietBi = false;
      //   this.isActiveDichVu = false;
      //   this.isActiveHeThong = true;
      // }
      this.activeTab = tab; // Cập nhật giá trị activeTab

      this.showThietBi = tab === "ThietBi";
      this.showDichVu = tab === "DichVu";
      // this.showHeThong = tab === 'HeThong';
    },
  },
};
</script>
  
  